export default "__VITE_ASSET__DLtQOKxW__"